import React from 'react';
import { Dialog, useMediaQuery, useTheme } from '@mui/material';
import StationSetup from './StationSetup';
import { Station, StationInfo } from '../types';

interface StationSetupModalProps {
  open: boolean;
  onClose: () => void;
  onFavouritesChange: (stations: Station[]) => void;
  stationSuggestions?: StationInfo[];
  timeSavedThreshold?: number;
  onTimeSavedThresholdChange?: (threshold: number) => void;
}

const StationSetupModal: React.FC<StationSetupModalProps> = ({
  open,
  onClose,
  onFavouritesChange,
  stationSuggestions,
  timeSavedThreshold,
  onTimeSavedThresholdChange,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      scroll="paper"
      aria-labelledby="station-setup-title"
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : 3,
          m: fullScreen ? 0 : 2,
          maxHeight: fullScreen ? '100%' : '88vh',
        },
      }}
    >
      <StationSetup
        onFavouritesChange={onFavouritesChange}
        onClose={onClose}
        stationSuggestions={stationSuggestions}
        timeSavedThreshold={timeSavedThreshold}
        onTimeSavedThresholdChange={onTimeSavedThresholdChange}
      />
    </Dialog>
  );
};

export default StationSetupModal;
